/**
 * Random Picker - Random Number Generator & Selection Tool
 * Free online random picker tool for numbers, lists, coins, and dice
 */
(function() {
    'use strict';

    /**
     * Generate cryptographically secure random number
     * @param {number} min - Minimum value (inclusive)
     * @param {number} max - Maximum value (inclusive)
     * @returns {number} Random number between min and max
     */
    function secureRandom(min, max) {
        const range = max - min + 1;
        const array = new Uint32Array(1);
        crypto.getRandomValues(array);
        return min + (array[0] % range);
    }

    // ========== MODE SWITCHING ==========
    document.querySelectorAll('.picker-tabs .nav-link').forEach(function(tab) {
        tab.addEventListener('click', function() {
            document.querySelectorAll('.picker-tabs .nav-link').forEach(function(t) {
                t.classList.remove('active');
            });
            tab.classList.add('active');
            
            const mode = tab.dataset.mode;
            document.querySelectorAll('.picker-card').forEach(function(card) {
                card.classList.add('d-none');
            });
            document.getElementById(mode + '-mode').classList.remove('d-none');
        });
    });

    // ========== NUMBER GENERATOR ==========
    const numberHistory = [];
    
    document.getElementById('btn-generate-number').addEventListener('click', function() {
        const min = parseInt(document.getElementById('num-min').value) || 1;
        const max = parseInt(document.getElementById('num-max').value) || 100;
        const count = Math.min(parseInt(document.getElementById('num-count').value) || 1, 100);
        const unique = document.getElementById('num-unique').checked;

        if (min > max) {
            var numberError = document.getElementById('number-error');
            numberError.textContent = 'Minimum must be less than maximum';
            numberError.classList.remove('d-none');
            return;
        }

        if (unique && (max - min + 1) < count) {
            var numberError2 = document.getElementById('number-error');
            numberError2.textContent = 'Not enough unique numbers in range';
            numberError2.classList.remove('d-none');
            return;
        }

        document.getElementById('number-error').classList.add('d-none');

        const numbers = [];
        const used = new Set();

        while (numbers.length < count) {
            const num = secureRandom(min, max);
            if (!unique || !used.has(num)) {
                numbers.push(num);
                used.add(num);
            }
        }

        // Animate result
        const resultDisplay = document.getElementById('number-result');
        const resultNumber = resultDisplay.querySelector('.result-number');
        resultDisplay.classList.add('animate');
        
        setTimeout(function() {
            resultNumber.innerHTML = numbers.join(count > 1 ? ', ' : '');
            resultDisplay.classList.remove('animate');
        }, 300);

        // Add to history
        numberHistory.unshift(numbers.join(', '));
        if (numberHistory.length > 10) numberHistory.pop();
        updateNumberHistory();
    });

    /**
     * Update number generator history display
     */
    function updateNumberHistory() {
        const historySection = document.getElementById('number-history');
        const historyList = document.getElementById('number-history-list');
        
        if (numberHistory.length > 0) {
            historySection.classList.remove('d-none');
            historyList.innerHTML = numberHistory.map(function(n) {
                return '<span class="history-item">' + n + '</span>';
            }).join('');
        } else {
            historySection.classList.add('d-none');
        }
    }

    document.getElementById('btn-clear-number-history').addEventListener('click', function() {
        numberHistory.length = 0;
        updateNumberHistory();
    });

    // ========== LIST PICKER ==========
    const listTextarea = document.getElementById('list-items');
    
    listTextarea.addEventListener('input', updateListCount);
    
    /**
     * Update list item count display
     */
    function updateListCount() {
        const items = listTextarea.value.split('\n').filter(function(item) {
            return item.trim();
        });
        document.getElementById('list-item-count').textContent = items.length + ' items in list';
    }

    document.getElementById('btn-pick-list').addEventListener('click', function() {
        const items = listTextarea.value.split('\n').filter(function(item) {
            return item.trim();
        });
        const count = Math.min(parseInt(document.getElementById('list-count').value) || 1, items.length);
        const remove = document.getElementById('list-remove').checked;

        if (items.length === 0) {
            var listError = document.getElementById('list-error');
            listError.textContent = 'Please enter some items first';
            listError.classList.remove('d-none');
            return;
        }

        document.getElementById('list-error').classList.add('d-none');

        const picked = [];
        const available = items.slice();

        for (let i = 0; i < count && available.length > 0; i++) {
            const index = secureRandom(0, available.length - 1);
            picked.push(available[index]);
            available.splice(index, 1);
        }

        // Display result
        const resultDisplay = document.getElementById('list-result');
        resultDisplay.classList.add('animate');
        
        setTimeout(function() {
            resultDisplay.querySelector('.result-text').innerHTML = picked.map(function(p) {
                return '<span class="picked-item">&#x2713; ' + p + '</span>';
            }).join('');
            resultDisplay.classList.remove('animate');
        }, 300);

        // Remove picked items if option checked
        if (remove) {
            listTextarea.value = available.join('\n');
            updateListCount();
        }
    });

    // ========== COIN FLIP ==========
    let headsCount = 0;
    let tailsCount = 0;

    document.getElementById('btn-flip-coin').addEventListener('click', function() {
        const coin = document.getElementById('coin');
        const isHeads = secureRandom(0, 1) === 0;
        
        coin.classList.add('flipping');
        
        setTimeout(function() {
            coin.className = 'coin';
            coin.classList.add(isHeads ? 'heads' : 'tails');
            
            if (isHeads) headsCount++;
            else tailsCount++;
            
            document.getElementById('heads-count').textContent = headsCount;
            document.getElementById('tails-count').textContent = tailsCount;
        }, 600);
    });

    document.getElementById('btn-reset-coin').addEventListener('click', function() {
        headsCount = 0;
        tailsCount = 0;
        document.getElementById('heads-count').textContent = '0';
        document.getElementById('tails-count').textContent = '0';
        document.getElementById('coin').className = 'coin';
    });

    // ========== DICE ROLL ==========
    const diceHistory = [];
    const diceEmojis = {
        6: ['\u2680', '\u2681', '\u2682', '\u2683', '\u2684', '\u2685']
    };

    /**
     * Get dice display character
     * @param {number} value - Dice value
     * @param {number} sides - Number of sides
     * @returns {string} Display character
     */
    function getDiceDisplay(value, sides) {
        if (sides === 6 && value >= 1 && value <= 6) {
            return diceEmojis[6][value - 1];
        }
        return value;
    }

    document.getElementById('btn-roll-dice').addEventListener('click', function() {
        const count = parseInt(document.getElementById('dice-count').value);
        const sides = parseInt(document.getElementById('dice-sides').value);
        const container = document.getElementById('dice-container');
        
        // Create dice elements
        container.innerHTML = '';
        const results = [];
        
        for (let i = 0; i < count; i++) {
            const value = secureRandom(1, sides);
            results.push(value);
            
            const dice = document.createElement('div');
            dice.className = 'dice rolling';
            dice.innerHTML = '<span>' + getDiceDisplay(value, sides) + '</span>';
            container.appendChild(dice);
            
            setTimeout(function(diceElement) {
                return function() {
                    diceElement.classList.remove('rolling');
                };
            }(dice), 500 + i * 100);
        }

        const total = results.reduce(function(a, b) {
            return a + b;
        }, 0);
        
        setTimeout(function() {
            document.getElementById('dice-total').textContent = total;
        }, 500 + count * 100);

        // Add to history
        diceHistory.unshift(count + 'd' + sides + ': ' + results.join(' + ') + ' = ' + total);
        if (diceHistory.length > 10) diceHistory.pop();
        updateDiceHistory();
    });

    /**
     * Update dice roll history display
     */
    function updateDiceHistory() {
        const historySection = document.getElementById('dice-history');
        const historyList = document.getElementById('dice-history-list');
        
        if (diceHistory.length > 0) {
            historySection.classList.remove('d-none');
            historyList.innerHTML = diceHistory.map(function(h) {
                return '<div class="history-item">' + h + '</div>';
            }).join('');
        } else {
            historySection.classList.add('d-none');
        }
    }

    document.getElementById('btn-clear-dice-history').addEventListener('click', function() {
        diceHistory.length = 0;
        updateDiceHistory();
    });

    // Initialize
    updateListCount();
})();
